<template>
    <div>
        <form @submit.prevent="add">
            <div class="form-row">
                <div class="col-sm-9 col-md-9 col-xl-9 mb-2 mb-sm-0">
                    <textarea ref="ta" @keydown="onKeydown" :rows="rows" type="text" class="form-control" id="text" v-model="text" :class="{ 'is-invalid': form.errors.has('text') }" placeholder="Текст комментария, Shift+Enter для новой строки"></textarea>
                    <has-error :form="form" field="text"/>
                </div>
                <div class="col-sm-3 col-md-3 col-xl-3">
                    <v-button :loading="form.busy" :large="false" :type="'primary'" :class="'btn-block'">Добавить</v-button>
                </div>
            </div>
            <div class="form-group">

            </div>
            <div class="form-group">

            </div>
        </form>
    </div>
</template>

<script>
    import VButton from "../../Button";
    import Form from 'vform';
    import toastr from "toastr";


    export default {
        name: "AddRequestComment",
        components: {VButton},
        props: ['request_id'],
        data: () => ({
            text: '',
            rows: 1,
            form: new Form(),
        }),
        methods: {
            async add () {
                if (this.validate()) {
                    this.form.request_id = this.request_id;
                    this.form.text = this.text;

                    const {data} = await this.form.post('/api/request_comments');
                    this.text = '';
                    this.rows = 1;
                    toastr.success('Добавлен комментарий');
                    this.$bus.$emit('request.' + this.request_id + '.comment:create');
                }
            },
            validate: function () {
                this.form = new Form();
                if (this.text.length <= 0) {
                    this.form.errors.set('text', ['Текст не может быть пустым']);
                    return false;
                }
                return  true;
            },
            onKeydown(e) {
                // ловим Shift+Enter
                if (e.shiftKey && e.key === 'Enter') {
                    e.preventDefault()
                    const ta = this.$refs.ta
                    const start = ta.selectionStart
                    const end   = ta.selectionEnd

                    // вставляем \n в модель
                    this.text =
                        this.text.slice(0, start) +
                        '\n' +
                        this.text.slice(end)

                    // увеличиваем видимое число строк
                    this.rows++

                    // после обновления DOM возвращаем курсор на новую строку
                    this.$nextTick(() => {
                        const pos = start + 1
                        ta.selectionStart = ta.selectionEnd = pos
                    })
                } else if (!e.shiftKey && e.key === 'Enter') {
                    e.preventDefault();
                    this.add();
                }
            },
        }
    }
</script>

<style scoped>

</style>
